<template>
  <svg :width="radius * 2 + 4" :height="radius * 2 + 4">
    <circle
      stroke="red"
      fill="transparent"
      stroke-width="1.5px"
      :cx="radius + 2"
      :cy="radius + 2"
      :r="radius"
      v-if="!start || end || (!start && !end)"
    />
    <path
      v-if="visited"
      :d="checkPath"
      stroke-width="5"
      fill="transparent"
      stroke="green"
    />
    <circle
      v-if="end"
      stroke="red"
      fill="transparent"
      stroke-width="1.5px"
      :cx="radius + 2"
      :cy="radius + 2"
      :r="radius * 0.8"
    />
    <path
      v-if="start"
      stroke="red"
      :d="startPath"
      stroke-width="1.5"
      fill="transparent"
    />
  </svg>
</template>
<script setup lang="ts">
const props = defineProps({
  radius: {
    type: Number,
    default: 50,
  },
  start: {
    type: Boolean,
    default: false,
  },
  end: {
    type: Boolean,
    default: false,
  },
  visited: Boolean,
});

const checkPath = computed(() => {
  const factor = props.radius / 12;
  return `M${5 * factor},${10 * factor} L${12 * factor},${16 * factor} L${
    24 * factor
  },0`;
});

const startPath = computed(() => {
  const factor = 1;
  function atAngle(angle: number): string {
    return `${
      props.radius * factor * Math.sin((angle * Math.PI) / 180) +
      props.radius +
      2
    },${
      props.radius * factor * Math.cos((angle * Math.PI) / 180) +
      props.radius +
      2
    }`;
  }
  return `M${atAngle(180)} L${atAngle(300)} L${atAngle(60)} Z`;
});
</script>
<style scoped>
.mapboxgl-marker-anchor-center svg {
  margin-top: 6px;
}
</style>
